import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import SetTitle from "../../utils/set_title";
import {BASE_URL} from "../../utils";


export default function ContentGenFile() {
	SetTitle('Content Gen - Download File')
	const params = useParams()

	useEffect(() => {
    	downloadData()
  	}, [])

	const downloadData = () => {
		if (params?.id) {
			setTimeout(() => {
				window.location.href = BASE_URL+'/api/1/get-content-gen-file/'+params.id
				setTimeout(() => {
					window.location.href = '/content-gen'
				}, 5000)
			}, 1000)
		}
		else {
			setTimeout(() => {
				window.location.href = '/content-gen'
			}, 1000)
		}
	}

	return (
		<>
			<div className="bg-gradient-info secondary-page-title" >
				<div md={12} className="form-title">
					<i className="ni ni-folder-17 text-white" style={{ color: "white", fontSize: "35px" }}></i>
					<h1 className="page-title">Content Gen</h1>
				</div>
			</div>
			<div className="page-description">Download in corso...</div>
		</>
	)
}
